import React from "react";
import { OrderedListOutlined } from "@ant-design/icons";
import { DataTable } from "./DataTable";
import { YhBox } from "@components/YhBox";

export const DataBox = () => {

    return (
        <YhBox title={<OrderedListOutlined />}   style={{height:'calc(100vh - 185px)'}}>
            <DataTable />
        </YhBox>
    )
}